<script setup>

import { ref, onMounted, computed, onUnmounted, defineModel, watch } from 'vue' 
import { useTheme } from 'vuetify'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import StatisticApi from '../services/StatisticApi'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const theme = useTheme()
const original = ref([]);
const labels = ref([]);
const label1 = ref('');
const label2 = ref('');
const data1 = ref([]);
const data2 = ref([]);
const model = defineModel({type: Object, default: { start: null, end: null, startCompare: null, endCompare: null } })

const width = ref(window.innerWidth)
const height = ref(window.innerHeight)

onMounted(() => {
    loadData();
});

const onResize = () => {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
}

window.addEventListener("resize", onResize);

onUnmounted(() => {
    window.removeEventListener("resize", onResize);
});

const chartOptions = computed(() => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: theme.current.value.colors['on-label']
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: theme.current.value.colors['on-label']
                },
                grid: {
                    color: theme.current.value.colors['on-grid']
                },
                title: {
                    color: theme.current.value.colors['on-label']
                }
            },
            y: {
                ticks: {
                    color: theme.current.value.colors['on-label']
                },
                grid: {
                    color: theme.current.value.colors['on-grid']
                }
            }
        }
      }
})

const chartData = computed(() => {
    return {
        labels: labels.value,
        datasets: [ 
            { 
                label: label2.value,
                backgroundColor: theme.current.value.colors['on-bar2'],
                data: data2.value,
                categoryPercentage: 0.3,
                barPercentage: 0.8,
                borderRadius: 10
            },
            { 
                label: label1.value,
                backgroundColor: theme.current.value.colors['on-bar1'],
                data: data1.value,
                categoryPercentage: 0.3,
                barPercentage: 0.8,
                borderRadius: 10
            }
        ]
    }
});

const loadData = () => {
    if(model.value.start && model.value.end && model.value.startCompare && model.value.endCompare) {
        let sDay = model.value.start.getDate()
        let eDay = model.value.end.getDate()
        let csDay = model.value.startCompare.getDate()
        let ceDay = model.value.endCompare.getDate()
        let eMonth = new Intl.DateTimeFormat("en-US", { month: "short" }).format(model.value.end)
        let ceMonth = new Intl.DateTimeFormat("en-US", { month: "short" }).format(model.value.endCompare)
        label1.value = `${sDay} / ${eDay} ${eMonth}`
        label2.value = `${csDay} / ${ceDay} ${ceMonth}`

        StatisticApi.getWeeklyStatistics({ 
            end: model.value.end.toISOString(),
            start: model.value.start.toISOString(),
            startCompare: model.value.startCompare.toISOString(),
            endCompare: model.value.endCompare.toISOString()
        }).then((response) => {
            if (response && response.data) {
                loadDataInChart(response.data)
            }
        }).catch((e) => {
            console.log(e)
        });
    }
}

const loadDataInChart = (data) => {
    
    original.value = data;
    labels.value = [];
    data1.value = [];
    data2.value = [];
    if(!data.items)
        return;

    if(model.value.start && model.value.end && model.value.startCompare && model.value.endCompare) {
        let days = 7;
        let cursorDate = new Date(model.value.start);
        for(var i = 0; i < days; i++) {
            let crtDate = new Date(cursorDate);
            labels.value.push(new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(crtDate));
            cursorDate.setDate(cursorDate.getDate() + 1);
            let crtElm = data.items.find((elm) => { return (new Date(elm.date)).getTime() == crtDate.getTime(); } )
            if(crtElm && crtElm.currentHours) {
                data1.value.push(crtElm.currentHours);
            }
            if (crtElm && crtElm.otherHours) {
                data2.value.push(crtElm.otherHours);
            }
        }
    }
}

watch(model, () => {
    loadData();
})


</script>

<template>
    <Bar
        id="weekly-statistics-box"
        :options="chartOptions"
        :data="chartData"
        style="width: 100%; height: 250px;"
    />
</template>

